<su-headline h="h1" skin="primary">{{ config.title }}</su-headline>
<form (ngSubmit)="validateForm()" [formGroup]="form">
  <su-card [card]="config.card">
    <div card-content>
      <formly-form
        [fields]="config.formFields"
        [form]="form"
        [model]="config.formModel"
        [options]="config.options ?? {}"
      ></formly-form>
    </div>
  </su-card>
</form>
